module.exports = __webpack_public_path__ + "static/media/cliente-dkbr.ad50bc9e.webp";